import React from 'react';
import { Text, Box } from '@mantine/core';
import { DateTimePicker } from '@mantine/dates';

const LabeledDateTimePicker = ({ 
  label, 
  placeholder, 
  value, 
  onChange, 
  disabled = false,
  minDate = null,
  maxDate = null
}) => {
  return (
    <Box>
      <Text size="md" weight={500} mb={8}>
        {label}
      </Text>
      <DateTimePicker
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        style={{ width: "100%", fontSize: "16px" }}
        styles={{
          input: {
            fontSize: "16px",
            height: "44px"
          },
          dropdown: {
            zIndex: 20000
          }
        }}
        dropdownZIndex={20000}
              />
    </Box>
  );
};

export default LabeledDateTimePicker; 